var _g, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 30",
    style: {
      enableBackground: "new 0 0 24 24",
      cursor: "pointer"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,11.4V9c0-3-2.2-5.4-5-5.9V3c0-0.6-0.4-1-1-1s-1,0.4-1,1v0.1C8.2,3.6,6,6,6,9v2.4c0,2.2-0.6,4.3-1.8,6.1   c-0.2,0.3-0.2,0.7,0,1S4.6,19,5,19h14c0.4,0,0.7-0.2,0.9-0.5s0.2-0.7,0-1C18.6,15.6,18,13.6,18,11.4z M6.7,17   C7.6,15.3,8,13.3,8,11.4V9c0-2.2,1.8-4,4-4s4,1.8,4,4v2.4c0,2,0.4,3.9,1.3,5.6H6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,22c1.1,0,2-0.9,2-2h-4C10,21.1,10.9,22,12,22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9,4.2c-0.3-0.4-1-0.5-1.4-0.2c-0.4,0.3-0.5,1-0.2,1.4c0.8,1,1.2,2.3,1.4,3.6c0.1,0.5,0.5,0.9,1,0.9c0,0,0.1,0,0.1,0   c0.5-0.1,0.9-0.6,0.9-1.1C21.5,7.1,20.9,5.5,19.9,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7,5.4C6,5,5.9,4.3,5.5,4C5,3.7,4.4,3.8,4.1,4.2c-1,1.3-1.6,2.9-1.8,4.5c-0.1,0.5,0.3,1,0.9,1.1c0,0,0.1,0,0.1,0   c0.5,0,0.9-0.4,1-0.9C4.5,7.7,5,6.4,5.7,5.4z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 39,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Mas Dhimas")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 44,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2f98244198f57bfbbc49324fe24ea8c3.svg";
export { ForwardRef as ReactComponent };